import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import styled, { keyframes } from "styled-components";
import ContentCard from "./ContentCard";
import sunnyImage from "../../images/AISunny.png";
import { handleLike, handleView } from "../../utils";

const profileImagePreload = new Image();
profileImagePreload.src = sunnyImage;

const ProfileCard = () => {
  const [imgLoaded, setImgLoaded] = useState(false);

  useEffect(() => {
    if (profileImagePreload.complete) {
      setImgLoaded(true);
      return;
    }

    const img = new Image();
    img.src = sunnyImage;
    img.onload = () => {
      setImgLoaded(true);
    };
    img.onerror = () => {
      setImgLoaded(true);
    };
  }, []);

  const handleBlog = async () => {
    window.open("https://blog.sunnytseng.com/", "_blank");
    const result = await handleView();
    console.log(result);
  };

  const onLike = async () => {
    Swal.fire({
      title: "Liking...",
      text: "Please wait while we confirm your like.",
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });
    const result = await handleLike();
    if (result.success) {
      const { ip_address, timestamp, total_likes } = result.data;

      Swal.fire({
        icon: "success",
        title: '<h2 style="color:#4CAF50;">Thank you! 👍</h2>',
        html: `
          <p style="font-size:1.1em; margin:10px 0;">
            <strong>Total Likes:</strong> ${total_likes}
          </p>
        `,
        background: "#f9f9f9",
        confirmButtonColor: "#4CAF50",
        confirmButtonText: "ok",
        // confirmButtonText: '<span style="font-size:1.1em;">You\'re welcome!</span>',
      });

      // 將 IP 和時間戳記錄到控制台
      console.log(`IP Address: ${ip_address}`);
      console.log(`Timestamp: ${timestamp}`);
    } else {
      // 處理已經點過讚的情況，顯示按讚人數
      const totalLikes = result.total_likes || 0; // 確保有按讚數
      Swal.fire({
        icon: "warning", // 使用 'warning' 圖示來搭配橘色主題
        title: '<h2 style="color:#e67e22;">Thank you! 😊</h2>', // 顏色改成橘色，並表達感謝
        html: `
          <p style="font-size:1.1em; color:#e67e22;">
            You have already liked this!
          </p>
          <p style="font-size:1.1em; margin:10px 0;">
            <strong>Total Likes:</strong> ${totalLikes}
          </p>
        `,
        background: "#fff7e6", // 使用淺橘色背景
        confirmButtonColor: "#e67e22", // 確認按鈕顏色設為橘色
        confirmButtonText: "Got it!",
      });
    }
  };

  return (
    <ProfileSection $loaded={imgLoaded}>
      {!imgLoaded ? (
        <Placeholder />
      ) : (
        <ContentCard
          image={sunnyImage}
          title="Sunny Tseng"
          subtitle="Christian"
          description="I enjoy discovering problems and trying to find ways to solve them, whether through programming or other means."
          onBlog={handleBlog}
          onLike={onLike}
        />
      )}
    </ProfileSection>
  );
};

export default ProfileCard;

/* ---------- Styled Components ---------- */

const shimmer = keyframes`
  0% { background-position: 120% 0; }
  100% { background-position: -120% 0; }
`;

const ProfileSection = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
  margin: 40px;
  background-color: ${({ $loaded }) => ($loaded ? "transparent" : "#fff")};
  transition: background-color 0.3s ease;

  [data-auth-theme="night"] & {
    background-color: ${({ $loaded }) => ($loaded ? "transparent" : "var(--app-surface, #2b2b2b)")};
  }

  @media (max-width: 768px) {
    height: auto;
    margin-top: 70px;
  }

  @media (max-width: 480px) {
    margin-bottom: 0px;
  }
`;

const Placeholder = styled.div`
  width: min(75vw, 700px);
  height: 420px;
  border-radius: 24px;
  background:
    linear-gradient(110deg, #171921 8%, #242733 18%, #171921 33%), #171921;
  background-size: 200% 100%;
  box-shadow: 0 80px 60px rgba(0, 0, 0, 0.12);
  animation: ${shimmer} 1.15s ease-in-out infinite;

  [data-auth-theme="night"] & {
    background-image: linear-gradient(110deg, var(--app-surface, #2b2b2b) 8%, var(--app-surface-hover, #424242) 18%, var(--app-surface, #2b2b2b) 33%);
    background-color: var(--app-surface, #2b2b2b);
  }

  @media (max-width: 600px) {
    width: 90vw;
    height: 360px;
  }
`;
